import { GatsbyImage } from 'gatsby-plugin-image';
import { SwiperSlide } from 'swiper/react';

import { Container, Section } from 'components/GridV2';
import { NavigationButtons, SwiperCarousel } from 'components/rebrand/SwiperCarousel';
import { H2 } from 'components/rebrand/Typography';

import { ISanityPhoneInstruction } from 'typescriptDefs';

interface Props {
  heading: string;
  items: ISanityPhoneInstruction[];
}

const HowItWorks = ({ heading, items }: Props) => {
  return (
    <Section className="px-32 py-64 md:px-[unset] md:py-96">
      <Container>
        <SwiperCarousel
          nextNavEl="referral-how-it-works-next"
          prevNavEl="referral-how-it-works-prev"
          breakpoints={{ 0: { slidesPerView: 1 } }}
          noNavigation
          slidesOffsetAfter={0}
        >
          {items.map((item) => (
            <SwiperSlide key={item.imgAltText}>
              <div className="grid items-center justify-center gap-64 md:grid-cols-2 md:justify-start md:gap-96">
                <div>
                  <H2 className="mb-16 text-primary-350">{heading}</H2>
                  <p className="mb-32 text-xl md:mb-64">{item.text}</p>
                  <NavigationButtons nextNavEl="referral-how-it-works-next" prevNavEl="referral-how-it-works-prev" />
                </div>
                <div className="overflow-hidden rounded-24">
                  <GatsbyImage alt={item.imgAltText} image={item.img.asset.gatsbyImageData} />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </Container>
    </Section>
  );
};

export default HowItWorks;
